import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { FileText, FileSpreadsheet, UserCircle } from 'lucide-react';
import QuoteReports from './QuoteReports';
import InvoiceReports from './InvoiceReports';
import ClientReports from './ClientReports';

export default function FinanceReports() {
  const [tab, setTab] = useState('quotes');

  return (
    <div className="space-y-4" data-testid="finance-reports">
      <div>
        <h1 className="text-xl font-bold">Finance Reports</h1>
        <p className="text-sm text-muted-foreground">Quotes, invoices, and client analytics</p>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList data-testid="finance-report-tabs">
          <TabsTrigger value="quotes" data-testid="tab-quotes">
            <FileText className="w-3.5 h-3.5 mr-1.5" /> Quote Report
          </TabsTrigger>
          <TabsTrigger value="invoices" data-testid="tab-invoices">
            <FileSpreadsheet className="w-3.5 h-3.5 mr-1.5" /> Invoice Report
          </TabsTrigger>
          <TabsTrigger value="clients" data-testid="tab-clients">
            <UserCircle className="w-3.5 h-3.5 mr-1.5" /> Client Report
          </TabsTrigger>
        </TabsList>

        <TabsContent value="quotes" className="mt-4">
          <QuoteReports />
        </TabsContent>

        <TabsContent value="invoices" className="mt-4">
          <InvoiceReports />
        </TabsContent>

        <TabsContent value="clients" className="mt-4">
          <ClientReports />
        </TabsContent>
      </Tabs>
    </div>
  );
}
